import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'success' | 'ghost' | 'danger';

export function Button({
  variant = 'primary',
  size = 'md',
  type = 'button',
  className,
  children,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: 'sm' | 'md';
  children?: ReactNode;
}) {
  return (
    <button
      type={type}
      className={clsx(
        styles.btn,
        styles[variant],
        size === 'sm' && styles.sm,
        rest.disabled && styles.disabled,
        className
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
